/* eslint-disable react/prefer-stateless-function */
/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect } from "react";
import MainLayout from "../../layout/MainLayout";
import { useNavigate, useLocation } from "react-router-dom";
import Hero from "../../components/hero/Hero";
import Missionyvision from "./Mision";
import Values from "./Values";
import styled from "styled-components";

const Title = styled.h2`
  font-size: 2rem;
  margin-bottom: 10px;
  font-weight: bold;
  color: #041c40;
  text-align: center;
  font: normal normal bold 60px / 53px;
  padding-top:3rem;
`;

const Divider = styled.div`
  width: 100px;
  height: 3px;
  background-color: #f7bc0c;
  margin: 0 auto 30px;
`;

function AboutUs({ history }) {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const elementId = location.hash.substring(1);

    if (elementId) {
      let element = document.getElementById(elementId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  }, [location]);

  useEffect(() => {
    const elementId = location.hash.substring(1);

    if (elementId) {
      let element = document.getElementById(elementId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  }, [location]);

  return (
    <MainLayout history={navigate}>
      <div>
        <Hero title={"About Us"} />
      </div>
      <div className="pt-4" style={{ "background-color": "#f9f9f9", }}>
        <Title>About US</Title>
        <Divider />
        <Missionyvision />
      </div>
      <div className="container pt-5 pb-5" id="values">
        <Values />
      </div>
    </MainLayout>
  );
}
export default AboutUs;
